import React, { useEffect, useMemo } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { themeButtons } from '../../../css/themeButtons';
import Link from '@material-ui/core/Link';
import { NavLink } from 'react-router-dom';
import ObjectPhotoComponent from '../../ObjectPhoto/ObjectPhotoComponent';
import { useDispatch } from 'react-redux';
import { TOGGLE_PHOTO_IS_DONE } from '../../../globalState/app/constans';

const FastPhoto = (props) => {
  const dispatch = useDispatch();

  const { photosToDB, objectId, userRole, baseUrl, goPage } = props;

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [])
  
  const photos = useMemo(() => {
    if (!photosToDB) return [{}];

    return [...photosToDB];
  }, [photosToDB])


  const savePageHandler = () => {
    goPage('contacts');
    dispatch({ type: TOGGLE_PHOTO_IS_DONE, payload: true });
  };

  const buttons = themeButtons();

  return (
    <div className='stepByStepWrp'>
      <div className='stepByStepWrp__header'>
        <Typography
          variant='h5'
          component='h5'
          className='stepByStepWrp__title'
        >
          Фотографии объекта
        </Typography>
      </div>

      <div className='stepByStepWrp__body'>
        <div className="navbar__object-id badge bg-success me-0 me-sm-2 mb-3">id: {objectId}</div>
        <div className='mb-3'>
          <Link
            component={NavLink}
            target='_blank'
            to={`/mail-pages/2/`}
            className={`btn ${buttons.btnGreen}`}
            variant='outlined'
          >
            Рекомендации по заполнению
          </Link>
        </div>
        <div id='object-foto'>
          <ObjectPhotoComponent
            baseUrl={baseUrl}
            isMobile={false}
            userRole={userRole}
            objectId={objectId}
            aproovedPhotos={photos}
          />
        </div>
      </div>

      <div className='stepByStepWrp__actions'>
        <Button className={`btn`} onClick={() => goPage('about')}>
          Назад
        </Button>
        <Button
          className={`btn ${buttons.btnGreen}`}
          disabled={photos?.length < 5}
          onClick={savePageHandler}
        >
          Сохранить и продолжить
        </Button>
      </div>
    </div>
  );
};

export default FastPhoto;
